export enum TenantSwitchStep {
  PropertyLookup,
  Energy,
  Tenant,
  Landlord,
  Tcf,
  Consent,
  Summary,
  Confirmation,
}
